import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { formatDate } from "@angular/common";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class EvaluationService {
  private evalKey = 'evalData'; // Key for localStorage
  // private apiUrl = 'https://210.56.11.150:8243/configurationmanagement/globalsettings/1.0.0/api/v1/globalsettings/';
  // private attachmentUrl = 'https://210.56.11.150:8243/documentmanagementsystem/dms/1.0.0/api/v1/dms/uploadfilebypass';
  private apiUrl = 'https://apiprd.eprocure.gov.pk/configurationmanagement/globalsettings/1.0.0/api/v1/globalsettings/';
  private attachmentUrl = 'https://apiprd.eprocure.gov.pk/documentmanagementsystem/dms/1.0.0/api/v1/dms/uploadfilebypass';
  constructor(private http: HttpClient) { }

  setEvalData(tender: any) {
    localStorage.setItem(this.evalKey, JSON.stringify(tender));
  }

  getEvalData() {
    return JSON.parse(localStorage.getItem(this.evalKey) || 'null');
  }

  clearEvalData() {
    localStorage.removeItem(this.evalKey);
  }



}
